import { useEffect, useState } from 'react';

import { ReviewFormDialog } from '@/components/reviews-hub/dialogs/review-form-dialog';
import { fetchReviewAttorneys } from '@/components/reviews-hub/requests';
import type { AttorneyOption } from '@/components/reviews-hub/types';

export function AddReviewModal({
  onOpenChange,
  onCloseAutoFocus,
}: {
  onOpenChange: (open: boolean) => void;
  onCloseAutoFocus: (event: Event) => void;
}) {
  const [attorneys, setAttorneys] = useState<AttorneyOption[]>([]);
  useEffect(() => {
    let cancelled = false;
    void fetchReviewAttorneys()
      .then((options) => {
        if (!cancelled) setAttorneys(options);
      })
      .catch(() => {
        if (!cancelled) setAttorneys([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ReviewFormDialog
      open
      mode="create"
      attorneys={attorneys}
      onOpenChange={onOpenChange}
      onCloseAutoFocus={onCloseAutoFocus}
      // Refresh validation errors without rehydrating the editor's unsaved page data.
      formOptions={{ preserveState: true, preserveScroll: true, only: ['errors'] }}
    />
  );
}
